var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRows2 = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5 2.5H13.5V6.5H2.5V2.5ZM1.5 2.5C1.5 1.94769 1.94775 1.5 2.5 1.5H13.5C14.0522 1.5 14.5 1.94769 14.5 2.5V6.5C14.5 7.05231 14.0522 7.5 13.5 7.5H2.5C1.94775 7.5 1.5 7.05231 1.5 6.5V2.5Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.5 9.5H13.5V13.5H2.5V9.5ZM1.5 9.5C1.5 8.94769 1.94775 8.5 2.5 8.5H13.5C14.0522 8.5 14.5 8.94769 14.5 9.5V13.5C14.5 14.0523 14.0522 14.5 13.5 14.5H2.5C1.94775 14.5 1.5 14.0523 1.5 13.5V9.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRows2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rows-2.9df538b4f9e2947db5329d1abb85751b.svg";